<rk-library-upload-dnd *ngIf="!isChronic" [box]="currentBac"></rk-library-upload-dnd>
<ng-container
  *ngIf="
    bacLength || (!bacLength && isCurrentlyFiltered) || importingDefaultTracks;
    else noTracks
  "
>
  <div class="table-outline" [style.max-height.px]="getTableHeight()" #table>
    <ng-container *ngIf="!importingDefaultTracks; else isImporting">
      <ng-container *ngIf="(tracksObservable$ | async).length; else searchEmpty">
        <div class="table-head">
          <div
            class="header flex items-center"
            rkSort
            [(predicate)]="predicate"
            [(ascending)]="reverse"
            [callback]="transition.bind(this)"
          >
            <div class="default checkbox">
              <mat-checkbox
                *ngIf="!bacPlanLocked"
                (change)="toggleAll($event)"
                [checked]="
                  (tracksObservable$ | async).length > 0 &&
                  (numberTracksSelected$ | async) >=
                    completedTracksLength(tracksObservable$ | async)
                "
                [indeterminate]="
                  (tracksObservable$ | async).length > 0 &&
                  (numberTracksSelected$ | async) <
                    completedTracksLength(tracksObservable$ | async) &&
                  (numberTracksSelected$ | async) > 0
                "
              >
              </mat-checkbox>
            </div>
            <ng-container *ngIf="!(numberTracksSelected$ | async); else selectedActions">
              <div rkSortBy="title" class="default title">
                <span translate>MEDIA.COLUMNS.TITLE</span> <span class="fa"></span>
              </div>
              <div rkSortBy="artist" class="default artist">
                <span translate>MEDIA.COLUMNS.ARTIST</span> <span class="fa"></span>
              </div>
              <div rkSortBy="album" *ngIf="columns.album" class="default album">
                <span translate>MEDIA.COLUMNS.ALBUM</span> <span class="fa"></span>
              </div>
              <div
                rkSortBy="year"
                *ngIf="!isChronic && columns.year"
                class="default year"
              >
                <span translate>MEDIA.COLUMNS.YEAR</span> <span class="fa"></span>
              </div>
              <div
                rkSortBy="uploadDate"
                *ngIf="!isChronic && columns.addedDate"
                class="default added"
              >
                <span translate>MEDIA.COLUMNS.ADDED</span> <span class="fa"></span>
              </div>
              <div #playlistRef *ngIf="columns.playlists" class="default playlists">
                <span translate>MEDIA.COLUMNS.PLAYLISTS</span> <span class="fa"></span>
              </div>
              <div #tagRef *ngIf="columns.tags && !isChronic" class="default tags">
                <span>Tags</span> <span class="fa"></span>
              </div>
              <div
                rkSortBy="timeSeconds"
                *ngIf="columns.duration"
                class="default duration"
              >
                <span translate>MEDIA.COLUMNS.DURATION</span> <span class="fa"></span>
              </div>
              <div rkSortBy="bpm" *ngIf="!isChronic && columns.bpm" class="default bpm">
                <span>BPM</span> <span class="fa"></span>
              </div>
              <div
                rkSortBy="bitrate"
                *ngIf="!isChronic && columns.kbps"
                class="default bpm"
              >
                <span>Kbps</span> <span class="fa"></span>
              </div>
            </ng-container>
            <ng-template #selectedActions>
              <span class="selected-count">{{
                'MEDIA.TABLE.TRACKS_SELECTED'
                  | translate: { nb: numberTracksSelected$ | async }
              }}</span>
              <rk-button
                *ngIf="!isChronic"
                class="selected-button"
                (click)="editMultipleTracks()"
                btnStyle="link"
                [style]="getMultiSelectButtonStyle()"
                [label]="'MEDIA.CONTEXT_MENU.EDIT' | translate"
              ></rk-button>
              <rk-button
                #headerAction
                *ngIf="!isChronic"
                class="selected-button"
                (click)="moveTracks()"
                btnStyle="link"
                [style]="getMultiSelectButtonStyle()"
                [label]="'MEDIA.TABLE.MOVE_BUTTON' | translate"
              ></rk-button>
              <rk-button
                #headerAction
                data-action="add-tags"
                *ngIf="!isChronic"
                class="selected-button"
                (click)="addTagsToTrack()"
                btnStyle="link"
                [style]="getMultiSelectButtonStyle()"
                [label]="
                  'MEDIA.TABLE.ADD_TAGS'
                    | translate: { count: (numberTracksSelected$ | async) }
                "
              ></rk-button>
              <rk-button
                #headerAction
                data-action="add-to-playlist"
                class="selected-button"
                [ngClass]="{ 'no-right-border': isChronic }"
                (click)="addTracksToPlaylist()"
                btnStyle="link"
                [style]="getMultiSelectButtonStyle()"
                [label]="'MEDIA.TABLE.ADD_TO_PLAYLIST_BUTTON' | translate"
              ></rk-button>
              <rk-button
                #headerAction
                data-action="remove-tags"
                class="selected-button"
                *ngIf="!isChronic && hasTags()"
                (click)="removeTagsFromTracks()"
                btnStyle="link"
                [style]="getMultiSelectButtonStyle()"
                [label]="
                  'MEDIA.TABLE.REMOVE_TAGS'
                    | translate: { count: (numberTracksSelected$ | async) }
                "
              ></rk-button>
              <rk-button
                #headerAction
                data-action="delete"
                class="selected-button"
                *ngIf="!isChronic"
                (click)="archiveMultiple()"
                btnStyle="link"
                [style]="getMultiSelectButtonStyle()"
                [label]="'MEDIA.CONTEXT_MENU.DELETE' | translate"
                [ngClass]="{ 'no-right-border': !hiddenActions.length }"
              ></rk-button>

              <mat-menu #tableMenu="matMenu" [overlapTrigger]="false">
                <ng-container>
                  <button
                    *ngIf="!isChronic && showOnHeaderContextMenu('add-tags')"
                    mat-menu-item
                    (click)="addTagsToTrack()"
                  >
                    <mat-icon fontSet="fa" fontIcon="fa-tag"></mat-icon>
                    <span
                      translate
                      [translateParams]="{ count: (numberTracksSelected$ | async) }"
                      >MEDIA.TABLE.ADD_TAGS</span
                    >
                  </button>
                  <ng-container *ngIf="showOnHeaderContextMenu('add-to-playlist')">
                    <button mat-menu-item (click)="addTracksToPlaylist()">
                      <mat-icon fontSet="fa" fontIcon="fa-indent"></mat-icon>
                      <span translate>MEDIA.TABLE.ADD_TO_PLAYLIST_BUTTON</span>
                    </button>
                    <mat-divider></mat-divider>
                  </ng-container>
                  <ng-container
                    *ngIf="hasTags() && showOnHeaderContextMenu('remove-tags')"
                  >
                    <button mat-menu-item (click)="removeTagsFromTracks()">
                      <mat-icon fontSet="fa" fontIcon="fa-tags"></mat-icon>
                      <span
                        translate
                        [translateParams]="{ count: (numberTracksSelected$ | async) }"
                        >MEDIA.TABLE.REMOVE_TAGS</span
                      >
                    </button>
                    <mat-divider></mat-divider>
                  </ng-container>
                  <button
                    *ngIf="showOnHeaderContextMenu('delete')"
                    mat-menu-item
                    (click)="archiveMultiple()"
                  >
                    <mat-icon fontSet="fa" fontIcon="fa-trash"></mat-icon>
                    <span translate>MEDIA.CONTEXT_MENU.DELETE</span>
                    <rk-hotkeys-help-clue [hotkey]="'delete'"></rk-hotkeys-help-clue>
                  </button>
                </ng-container>
              </mat-menu>
              <rk-icon-button
                *ngIf="!isChronic && hiddenActions.length"
                class="ml-2"
                [svgIcon]="'dot-down'"
                [color]="'brand'"
                [matMenuTriggerFor]="tableMenu"
              >
              </rk-icon-button>
            </ng-template>
          </div>

          <div class="overlay-right" *ngIf="!(numberTracksSelected$ | async)">
            <mat-menu #appMenu="matMenu" [overlapTrigger]="false">
              <div class="drop-columns">
                <div class="header-drop" translate>MEDIA.COLUMNS.HEADER_MENU</div>

                <div (click)="$event.stopPropagation()">
                  <mat-checkbox
                    class="small-box"
                    [checked]="columns.album"
                    (change)="requestToggleColumn('album')"
                  >
                    <span translate>MEDIA.COLUMNS.ALBUM</span>
                  </mat-checkbox>
                </div>

                <div (click)="$event.stopPropagation()" *ngIf="!isChronic">
                  <mat-checkbox
                    class="small-box"
                    [checked]="columns.year"
                    (change)="requestToggleColumn('year')"
                  >
                    <span translate>MEDIA.COLUMNS.YEAR</span>
                  </mat-checkbox>
                </div>

                <div (click)="$event.stopPropagation()" *ngIf="!isChronic">
                  <mat-checkbox
                    class="small-box"
                    [checked]="columns.addedDate"
                    (change)="requestToggleColumn('addedDate')"
                  >
                    <span translate>MEDIA.COLUMNS.ADDED</span>
                  </mat-checkbox>
                </div>

                <div (click)="$event.stopPropagation()">
                  <mat-checkbox
                    class="small-box"
                    [checked]="columns.playlists"
                    (change)="requestToggleColumn('playlists')"
                  >
                    <span translate>MEDIA.COLUMNS.PLAYLISTS</span>
                  </mat-checkbox>
                </div>

                <div (click)="$event.stopPropagation()" *ngIf="!isChronic">
                  <mat-checkbox
                    class="small-box"
                    [checked]="columns.tags"
                    (change)="requestToggleColumn('tags')"
                  >
                    <span>Tags</span>
                  </mat-checkbox>
                </div>

                <div (click)="$event.stopPropagation()">
                  <mat-checkbox
                    class="small-box"
                    [checked]="columns.duration"
                    (change)="requestToggleColumn('duration')"
                  >
                    <span translate>MEDIA.COLUMNS.DURATION</span>
                  </mat-checkbox>
                </div>

                <div (click)="$event.stopPropagation()" *ngIf="!isChronic">
                  <mat-checkbox
                    class="small-box"
                    [checked]="columns.bpm"
                    (change)="requestToggleColumn('bpm')"
                  >
                    <span>BPM</span>
                  </mat-checkbox>
                </div>

                <div (click)="$event.stopPropagation()" *ngIf="!isChronic">
                  <mat-checkbox
                    class="small-box"
                    [checked]="columns.kbps"
                    (change)="requestToggleColumn('kbps')"
                  >
                    <span>Kbps</span>
                  </mat-checkbox>
                </div>
              </div>
            </mat-menu>

            <button mat-icon-button [matMenuTriggerFor]="appMenu" class="svg-gray-dark">
              <mat-icon [svgIcon]="'dot-standing'"></mat-icon>
            </button>
          </div>
        </div>

        <div class="body-array cdk-custom-container flex flex-1">
          <cdk-virtual-scroll-viewport
            itemSize="50"
            class="flex-1"
            minBufferPx="800"
            maxBufferPx="1000"
            (scroll)="onCloseContextMenu()"
          >
            <rk-library-audio-line
              #audioLine
              *cdkVirtualFor="
                let item of tracksObservable$ | async;
                templateCacheSize: 60
              "
              (shiftClicked)="onSelectShiftLine($event)"
              (editTrack)="editTrack(item)"
              [track]="item"
              [columns]="columns"
              [contextMenu]="isMultiSelect(item.id) ? multiCtxMenu : ctxMenu"
              [isContextMenuOpen]="item.id === trackOpen?.id"
              [isChronic]="isChronic"
              [currentBacName]="currentBacName"
              [hasPaddingRight]="!hasScroll"
              [tagDisplayedLimiter]="tagDisplayedLimiter"
              [isPlaying]="isPlaying$ | async"
              [isLoaded]="(currentTrackPlaying$ | async)?.id === item.id"
              [linePlanLocked]="bacPlanLocked"
            ></rk-library-audio-line>
          </cdk-virtual-scroll-viewport>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-container>

<ng-template #searchEmpty>
  <div class="search-empty">
    <img src="/assets/search-empty.svg" alt="" />
    <div
      *ngIf="
        !isCurrentlyFiltered || (searchField$ && searchField$ | async);
        else emptyFilter
      "
    >
      {{ 'MEDIA.TABLE.SEARCH_EMPTY' | translate: { search: searchField$ | async } }}
    </div>
    <ng-template #emptyFilter>
      <div>{{ 'MEDIA.TABLE.FILTERS_EMPTY' | translate }}</div>
      <rk-button
        class="reset-filters"
        (click)="resetToDefault()"
        [label]="'MEDIA.FILTERS.SHELL.RESET_FILTERS' | translate"
      ></rk-button>
    </ng-template>
  </div>
</ng-template>

<ng-template #noTracks>
  <div *ngIf="currentBac.id !== 7; else noShoutouts" class="box-empty">
    <img src="/assets/box-empty.svg" />
    <div translate>MEDIA.TABLE.BOX_EMPTY</div>
    <rk-library-upload-track
      [box]="currentBac"
      [isMainButton]="false"
    ></rk-library-upload-track>
  </div>
</ng-template>

<ng-template #noShoutouts>
  <div class="box-empty shout-outs-empty">
    <img src="/assets/no-shout-outs.svg" />
    <div translate>MEDIA.TABLE.BOX_SHOUTOUTS_EMPTY</div>
  </div>
</ng-template>

<ng-template #isImporting>
  <rk-table-processing [text]="'MEDIA.TABLE.IMPORTING' | translate"></rk-table-processing>
</ng-template>

<context-menu
  #ctxMenu
  (open)="onOpenContextMenu($event.item)"
  (close)="onCloseContextMenu()"
>
  <ng-template contextMenuItem let-track [passive]="true">
    <div class="context-header">
      <img [src]="track.cover" />
      <div class="flex flex-col">
        <div class="header-track">{{ track.title }}</div>
        <div class="header-artist">{{ track.artist }}</div>
      </div>
    </div>
  </ng-template>
  <ng-template contextMenuItem [divider]="true"></ng-template>
  <ng-template contextMenuItem let-track (execute)="playTrack($event.item)">
    <mat-icon fontSet="fa" fontIcon="fa-play"></mat-icon>
    <span translate>MEDIA.CONTEXT_MENU.PLAY</span>
    <rk-hotkeys-help-clue [hotkey]="'playPause'"></rk-hotkeys-help-clue>
  </ng-template>
  <ng-template
    contextMenuItem
    let-track
    (execute)="editTrack($event.item)"
    [visible]="isNotLocked"
  >
    <mat-icon fontSet="fa" fontIcon="fa-pen"></mat-icon>
    <span translate>MEDIA.CONTEXT_MENU.EDIT</span>
    <rk-hotkeys-help-clue [hotkey]="'edit'"></rk-hotkeys-help-clue>
  </ng-template>
  <ng-template
    contextMenuItem
    (execute)="addTagsToTrack($event.item)"
    [visible]="isNotLocked"
  >
    <mat-icon fontSet="fa" fontIcon="fa-tag"></mat-icon>
    <span translate>MEDIA.CONTEXT_MENU.ADD_TAGS</span>
  </ng-template>
  <ng-template
    contextMenuItem
    let-track
    (execute)="editMixPointTrack($event.item)"
    [visible]="isNotLocked"
  >
    <mat-icon fontSet="fa" fontIcon="fa-sliders-h"></mat-icon>
    <span translate>MEDIA.CONTEXT_MENU.EDIT_MIX_THRESHOLD</span>
  </ng-template>
  <ng-template
    contextMenuItem
    let-track
    (execute)="downloadTrack($event.item)"
    [visible]="canDownloadTrack"
  >
    <mat-icon fontSet="fa" fontIcon="fa-download"></mat-icon>
    <span translate>MEDIA.CONTEXT_MENU.DOWNLOAD</span>
  </ng-template>
  <ng-template contextMenuItem [divider]="true" [visible]="!bacPlanLocked"></ng-template>
  <ng-template
    contextMenuItem
    let-track
    [visible]="!bacPlanLocked"
    (execute)="addTrackToPlaylist($event.item)"
  >
    <mat-icon fontSet="fa" fontIcon="fa-indent"></mat-icon>
    <span translate>MEDIA.TABLE.ADD_TO_PLAYLIST_BUTTON</span>
  </ng-template>
  <ng-template
    contextMenuItem
    let-track
    (execute)="moveTrack($event.item)"
    [visible]="isNotLocked"
  >
    <mat-icon fontSet="fa" fontIcon="fa-arrow-right"></mat-icon>
    <span translate>MEDIA.TABLE.MOVE_BUTTON</span>
  </ng-template>
  <ng-template contextMenuItem [divider]="true" [visible]="isNotLocked"></ng-template>
  <ng-template
    contextMenuItem
    let-track
    (execute)="removeTagsFromTracks($event.item)"
    [visible]="canRemoveTagsFromTracks"
  >
    <mat-icon fontSet="fa" fontIcon="fa-tags"></mat-icon>
    <span translate>MEDIA.CONTEXT_MENU.REMOVE_TAGS</span>
  </ng-template>
  <ng-template
    contextMenuItem
    [divider]="true"
    [visible]="canRemoveTagsFromTracks"
  ></ng-template>
  <ng-template
    contextMenuItem
    let-track
    (execute)="archiveTrack($event.item)"
    [visible]="isNotLocked"
  >
    <mat-icon fontSet="fa" fontIcon="fa-trash"></mat-icon>
    <span translate>MEDIA.CONTEXT_MENU.DELETE</span>
    <rk-hotkeys-help-clue [hotkey]="'delete'"></rk-hotkeys-help-clue>
  </ng-template>
</context-menu>

<context-menu
  #multiCtxMenu
  (open)="onOpenContextMenu($event.item)"
  (close)="onCloseContextMenu()"
>
  <ng-template contextMenuItem let-track [passive]="true">
    <div class="context-header">
      <div class="header-track">
        {{
          'MEDIA.TABLE.TRACKS_SELECTED' | translate: { nb: numberTracksSelected$ | async }
        }}
      </div>
    </div>
  </ng-template>
  <ng-template contextMenuItem [divider]="true"></ng-template>
  <ng-template contextMenuItem (execute)="editMultipleTracks()" [visible]="!isChronic">
    <mat-icon fontSet="fa" fontIcon="fa-pen"></mat-icon>
    <span translate>MEDIA.CONTEXT_MENU.EDIT</span>
    <rk-hotkeys-help-clue [hotkey]="'edit'"></rk-hotkeys-help-clue>
  </ng-template>
  <ng-template contextMenuItem (execute)="addTagsToTrack()" [visible]="!isChronic">
    <mat-icon fontSet="fa" fontIcon="fa-tag"></mat-icon>
    <span translate>MEDIA.CONTEXT_MENU.ADD_TAGS</span>
  </ng-template>
  <ng-template contextMenuItem [divider]="true" [visible]="!isChronic"></ng-template>
  <ng-template contextMenuItem (execute)="addTracksToPlaylist()">
    <mat-icon fontSet="fa" fontIcon="fa-indent"></mat-icon>
    <span translate>MEDIA.TABLE.ADD_TO_PLAYLIST_BUTTON</span>
  </ng-template>
  <ng-template contextMenuItem (execute)="moveTracks()" [visible]="!isChronic">
    <mat-icon fontSet="fa" fontIcon="fa-arrow-right"></mat-icon>
    <span translate>MEDIA.TABLE.MOVE_BUTTON</span>
  </ng-template>
  <ng-template contextMenuItem [divider]="true" [visible]="!isChronic"></ng-template>
  <ng-template
    contextMenuItem
    (execute)="removeTagsFromTracks()"
    [visible]="canRemoveTagsFromTracks"
  >
    <mat-icon fontSet="fa" fontIcon="fa-tags"></mat-icon>
    <span translate>MEDIA.CONTEXT_MENU.REMOVE_TAGS</span>
  </ng-template>
  <ng-template
    contextMenuItem
    [divider]="true"
    [visible]="canRemoveTagsFromTracks"
  ></ng-template>
  <ng-template contextMenuItem (execute)="archiveMultiple()" [visible]="!isChronic">
    <mat-icon fontSet="fa" fontIcon="fa-trash"></mat-icon>
    <span translate>MEDIA.CONTEXT_MENU.DELETE</span>
    <rk-hotkeys-help-clue [hotkey]="'delete'"></rk-hotkeys-help-clue>
  </ng-template>
</context-menu>
